// Same thresholds as the old architecture's classifyPotential (mockData.js),
// duplicated deliberately rather than imported — mockData.js stays untouched
// since Warehouse/SCM/Marketing/Admin/Country Manager still depend on it,
// and this new independent-data architecture shouldn't reach back into it.
export function classifyPotential(score) {
  if (score > 80) return 'Platinum';
  if (score > 65) return 'Gold';
  if (score > 50) return 'Silver';
  return 'Bronze';
}

// Same formula as recalculatePotentialScore in the old store, for consistency.
export function computePotentialScore(dailyFootfall, monthlyFootfall) {
  return Math.max(20, Math.min(100, Math.round(dailyFootfall / 3 + monthlyFootfall / 200)));
}

export const CATEGORY_CEILING = { A: 5000, B: 3000, C: 1500 };
